import * as XLSX from 'xlsx';
import { getSocieteInfos } from "./exportUtils";
import { formatCurrencyForExport, formatNumberForExport } from "./exportFormatters";

/**
 * Exporte les données CA vers Excel
 */
export const exportCAtoExcel = (data, selectedYear, selectedMonth) => {
  try {
    const societe = getSocieteInfos();
    const wb = XLSX.utils.book_new();
    const wsData = [];
    
    const mois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 
                  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    
    // En-tête du document
    wsData.push([`RAPPORT CHIFFRE D'AFFAIRES ${selectedYear}`]);
    wsData.push([societe.nom]);
    wsData.push([societe.adresse]);
    wsData.push([`Tél: ${societe.telephone} | Email: ${societe.email}`]);
    wsData.push([]);
    wsData.push([`Période: ${mois[selectedMonth-1]} ${selectedYear}`]);
    wsData.push([]);
    
    // Tableau journalier
    wsData.push(['Jour', 'CA Journalier (FCFA)', 'Nb Factures', 'Panier Moyen (FCFA)', 'TVA (FCFA)']);
    
    if (data?.mensuel_detail) {
      data.mensuel_detail.forEach(jour => {
        wsData.push([
          jour.jour,
          formatCurrencyForExport(jour.ca_journalier),
          formatNumberForExport(jour.nb_factures || 0),
          formatCurrencyForExport(jour.panier_moyen || 0),
          formatCurrencyForExport(jour.tva || 0)
        ]);
      });
    }
    
    wsData.push([]);
    
    // Totaux journaliers
    const totalCA = data?.mensuel_detail?.reduce((acc, j) => acc + (j.ca_journalier || 0), 0) || 0;
    const totalFactures = data?.mensuel_detail?.reduce((acc, j) => acc + (j.nb_factures || 0), 0) || 0;
    const totalTVA = data?.mensuel_detail?.reduce((acc, j) => acc + (j.tva || 0), 0) || 0;
    
    wsData.push([
      'TOTAL JOURNALIER',
      formatCurrencyForExport(totalCA),
      formatNumberForExport(totalFactures),
      '',
      formatCurrencyForExport(totalTVA)
    ]);
    
    wsData.push([]);
    wsData.push([]);
    
    // Tableau annuel
    wsData.push(['RÉSUMÉ MENSUEL']);
    wsData.push(['Mois', 'CA HT', 'TVA', 'CA TTC', 'Nb Factures', 'Nb Clients', 'Règlements']);
    
    if (data?.annuel) {
      data.annuel.forEach(mois => {
        wsData.push([
          mois.mois,
          formatCurrencyForExport(mois.total_ht || 0),
          formatCurrencyForExport(mois.total_tva || 0),
          formatCurrencyForExport(mois.total_ttc || 0),
          formatNumberForExport(mois.nb_factures || 0),
          formatNumberForExport(mois.nb_clients || 0),
          formatCurrencyForExport(mois.total_regle || 0)
        ]);
      });
    }
    
    // Créer la feuille
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    
    // Ajuster la largeur des colonnes
    ws['!cols'] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 }
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, "Chiffre d'affaires");
    
    const fileName = `CA_${selectedYear}_${selectedMonth}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    
    return true;
  } catch (error) {
    console.error("Erreur export Excel:", error);
    alert("Erreur lors de l'export Excel");
    return false;
  }
};

/**
 * Exporte les données au format CSV
 */
export const exportCAtoCSV = (data, selectedYear) => {
  try {
    const wsData = [];
    
    // En-têtes
    wsData.push(['Mois', 'CA HT', 'TVA', 'CA TTC', 'Nb Factures', 'Nb Clients']);
    
    // Données
    if (data?.annuel) {
      data.annuel.forEach(mois => {
        wsData.push([
          mois.mois,
          formatCurrencyForExport(mois.total_ht || 0),
          formatCurrencyForExport(mois.total_tva || 0),
          formatCurrencyForExport(mois.total_ttc || 0),
          formatNumberForExport(mois.nb_factures || 0),
          formatNumberForExport(mois.nb_clients || 0)
        ]);
      });
    }
    
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CA Annuel");
    
    const fileName = `CA_annuel_${selectedYear}_${new Date().toISOString().split('T')[0]}.csv`;
    XLSX.writeFile(wb, fileName, { bookType: 'csv' });
    
    return true;
  } catch (error) {
    console.error("Erreur export CSV:", error);
    return false;
  }
};